// import React from "react";
// import "./NewCompProfileUpdates.css";

// function NewCompProfileUpdates() {
//   return (
//     <div className="updates_section">
//       <div className="new_updates_block">
//         <div className="new_updates_subblock">
//           <div className="new_updates_dropdown">
//             <div className="new_flex">
//               <p className="new_flex_text">New :</p>
//             </div>
//             <select className="custom_dropdown">
//               <option value="" className="custom_dropdown_option">
//                 <p className="custom_dropdown_para">Select an Option</p>
//               </option>
//               <option value="financial" className="custom_dropdown_option">
//                 <p className="custom_dropdown_para">Added</p>
//               </option>
//               <option value="growth" className="custom_dropdown_option">
//                 <p className="custom_dropdown_para">Removed</p>
//               </option>
//               <option value="market" className="custom_dropdown_option">
//                 <p className="custom_dropdown_para">Update in progress</p>
//               </option>
//               <option value="market" className="custom_dropdown_option">
//                 <p className="custom_dropdown_para">Update completed</p>
//               </option>
//             </select>
//           </div>

//           <div className="new_updates">
//             <p className="new_updates_text">
//               Company Overview
//               {/* <span className="new_updates_number">6</span> */}
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default NewCompProfileUpdates;

import React from "react";
import "./NewCompProfileUpdates.css";

function NewCompProfileUpdates({ action, data = [], onActionChange }) {
  const scorecardItems = [
    "FinancialsStrategy_ScoreCard",
    "MarketPosition_ScoreCard",
    "MarketingDistributions_ScoreCard",
    "OpsSupply_ScoreCard",
    "OrgLeader_ScoreCard",
    "ProdInno_ScoreCard",
    "FinancialsStrategy ScoreCard",
    "MarketPosition ScoreCard",
    "MarketingDistributions ScoreCard",
    "OpsSupply ScoreCard",
    "OrgLeader ScoreCard",
    "ProdInno ScoreCard",
  ];

  const labelMap = {
    "Market by application": "By Application",
    "Market by technology": "By Technology",
    "Market by geography": "By Geography",
    "Future Bets": "Future Bets & Leadership-Led Initiatives",
    "Marketing Geographic Coverage": "Marketing & Geographic Coverage",
    "Quantitative Snapshot": "Quant Snapshot",
    "Org Chart": "Organizational Hierarchy",
    "Business Segment": "Business Segment Structure",
    "Strategic Themes": "Strategic Leadership Themes",
  };

  //Scorecard grouping logic
  const hasScorecard = data.some((item) => scorecardItems.includes(item));

  let filteredData = [
    ...data.filter((item) => !scorecardItems.includes(item)),
    ...(hasScorecard ? ["Company Scorecard"] : []),
  ];

  //Label mapping
  filteredData = filteredData.map((item) => labelMap[item] || item);

  return (
    <div className="updates_section">
      <div className="new_updates_block">
        <div className="new_updates_subblock">
          <div className="new_updates_dropdown">
            <div className="new_flex">
              <p className="new_flex_text">New :</p>
            </div>

            <select
              className="custom_dropdown"
              value={action || ""}
              onChange={(e) => onActionChange && onActionChange(e.target.value)}
            >
              <option value="" className="custom_dropdown_option">
                Select an Option
              </option>
              <option value="added" className="custom_dropdown_option">
                Added
              </option>
              <option value="removed" className="custom_dropdown_option">
                Removed
              </option>
              <option
                value="update_in_progress"
                className="custom_dropdown_option"
              >
                Update in progress
              </option>
              <option
                value="update_completed"
                className="custom_dropdown_option"
              >
                Update completed
              </option>
              <option
                value="added_by_others"
                className="custom_dropdown_option"
              >
                Added by others
              </option>
            </select>
          </div>

          {/* {data.map((item, index) => ( */}
          {filteredData.map((item, index) => (
            <div className="new_updates" key={index}>
              <p className="new_updates_text">
                {item}
                {/* <span className="new_updates_number">6</span> */}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default NewCompProfileUpdates;
